$( document ).ready(function() {
  var mrp = localStorage.getItem('mrp');
  var available_loc = localStorage.getItem('available_loc');
  var gst_state = localStorage.getItem('gst_state');
  var pincode = localStorage.getItem('pincode');
  //console.log("mrp",mrp);
  if((mrp == "") || (mrp == null)){
     $(".shopify-payment-button__button").attr("disabled","disabled");
     $(".product-form__submit").not(".verify__button").attr("disabled","disabled");
  }else{
    $(".shipping__verify").show();
    $(".shipping__verify__input input").val(pincode);
    getServicePincode();
  }
  $("#mrp").val(mrp);
  $("#loc").val(available_loc+"_"+gst_state);
  $(".shipping__verify").hide();
  $(".shipping__error").hide();
   
  $(".select__select").change(function(){
    //console.log($(this).attr('price'));
    //start disable atc button on change 15-12-22//
    $(".shopify-payment-button__button").attr("disabled","disabled");
    $(".product-form__submit").not(".verify__button").attr("disabled","disabled");
    //end disable atc button on change 15-12-22//
    var price = $(".select__select :selected").data("price")/100;
    var productSku = $(".select__select :selected").data("sku");
    $("#mrp").val(price);
    //console.log(productSku);
    getServicePincode();
  })
 
  $(".verify__button").click(function(){
      
      getServicePincode();
    });
  
});

function getServicePincode(){
      $(".verify__button").addClass("loading");
      $(".verify__button .loading-overlay__spinner").removeClass("hidden");
      //console.log("getServicePincode");
      
      var pincode = $(".shipping__verify__input input").val();
      var price = $(".select__select :selected").data("price")/100;
      //console.log($(".select__select :selected"));
      var productSku = $(".select__select :selected").data("sku");
       $(".shipping__verify").hide();
       $(".shipping__error").hide();
      
      $.ajax({
        //url:"https://myindiabazar.com/ensenterprises/built/excel_php/getDetailsViaPincode.php?pincode="+pincode+"&price="+price+"&sku="+productSku,
        url:"https://macroapp.buildyourgoals.com/excel_php/getDetailsViaPincode.php?pincode="+pincode+"&price="+price+"&sku="+productSku,
        type:"get",
        success:function(data){
          
          var json_data = data;
          //console.log(json_data);
          var error =  JSON.parse(json_data.error);
          if(error !=0 ){
              //console.log("In Not error blog");
              var gst_state = json_data.gst_state;
              var currentstock = JSON.parse(json_data.currentstock);
              
              if (currentstock.length != 0 ){
                var available_loc = currentstock[0].LocationCode;
                localStorage.setItem('mrp', price);
                localStorage.setItem('pincode',pincode);
                localStorage.setItem('available_loc', available_loc);
                localStorage.setItem('gst_state', gst_state);
                $("#mrp").val(price);
                $("#loc").val(available_loc+"_"+gst_state);
                var available_loc_qty = currentstock[0].StkQty;
                //console.log(available_loc,available_loc_qty);
                $(".shipping__error").hide();
                if(json_data.cod_status === "Yes") {
                   
               $(".shipping__verify").html("Both Prepaid & COD delivery options are available");
               //$(".shipping__verify").html("Currently, only prepaid option is available");
                  
                } else {
                  
                $(".shipping__verify").html("Only Prepaid delivery option is available");
                }
                $(".shipping__verify").show();
                setTimeout(function() {
                    // console.log("22222");
                    $(".shopify-payment-button__button").removeAttr("disabled");
                    $(".shopify-payment-button__button").css({
                      'cursor': 'pointer',
                      'pointer-events': 'visible',
                      'opacity': 1
                    });
                    $(".product-form__submit").removeAttr("disabled");
                    $(".product-form__submit").css({
                      'cursor': 'pointer',
                      'pointer-events': 'visible',
                      'opacity': 1
                    });
                }, 3500);
              }else{
              //   localStorage.setItem('mrp', "");
             //    localStorage.setItem('available_loc', "");
              //   localStorage.setItem('gst_state', "");
              //   localStorage.setItem('pincode',"");
            //     not available at this location

                //console.log("In else block")
                 $(".shopify-payment-button__button").attr("disabled", true);
                 $(".product-form__submit").not(".verify__button").attr("disabled", true);
                 $(".shipping__verify").hide();
                 $(".shipping__error").text("Sorry, this product is Sold Out")
                 $(".shipping__error").show();
            }
          }else{
            // not available at this location
            $(".shopify-payment-button__button").attr("disabled", true);
            $(".product-form__submit").not(".verify__button").attr("disabled", true);
            $(".shipping__verify").hide();
            $(".shipping__error").html("Sorry, we do not ship to this Pincode"); 
            $(".shipping__error").show();
          }
      $(".verify__button").removeClass("loading");
      $(".verify__button .loading-overlay__spinner").addClass("hidden");
          
        },
        error: function(jqXHR, textStatus, errorThrown) {
          //console.log(jqXHR, textStatus, errorThrown);
  	  }
      });
  }